
import React, { useState, useEffect } from "react";
import Axios from "../../_services/caller.service";
import styles from "./RemindersLateCalibration.module.scss";
import CardHeaderPage from "../UiComponents/card/CardHeaderPage";
import Modal from "../UiComponents/modals/Modal";
import InputForms from "../UiComponents/forms/InputForms";
import { toast } from "react-toastify";
import { PermissionGate } from "../superAdmin/managePermissions/PermissionGate";

const ReminderLateCalibration = ({setLoadingDataReminders}) => {
  const [reminders, setReminders] = useState([]);

  const [error, setError] = useState(null);
  const [emailStatuses, setEmailStatuses] = useState({});
  const [searchTerm, setSearchTerm] = useState(""); // Recherche
  const [filterReminderType, setFilterReminderType] = useState("all"); // Filtre type de relance
  const [filterStatus, setFilterStatus] = useState("all"); // Filtre statut email
  const [sortField, setSortField] = useState(null); // Tri
  const [sortOrder, setSortOrder] = useState("asc");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [selectedReminder, setSelectedReminder] = useState(null);
  const [userProfile, setUserProfile] = useState(null); // Pour récupérer le profil utilisateur

  // Fonction pour vérifier le statut de l'email
  const checkEmailStatus = async (messageId) => {
  try {
    const response = await Axios.get(`/getStatusEmailRemindersCalibration/${messageId}`);
    const events = response.data.events || [];

    let status = "No events found";

    if (events.length > 0) {
      // Cherche dans l'ordre d'importance : delivered > opened > clicked > bounced
      const deliveredEvent = events.find(e => e.event === "delivered");
      const openedEvent = events.find(e => e.event === "opened");
      const clickedEvent = events.find(e => e.event === "clicked");
      const hardBounceEvent = events.find(e => e.event === "hardBounces");
      const softBounceEvent = events.find(e => e.event === "softBounces");

      if (deliveredEvent) status = "delivered";
      else if (openedEvent) status = "opened";
      else if (clickedEvent) status = "clicked";
      else if (hardBounceEvent) status = "hardBounces";
      else if (softBounceEvent) status = "softBounces";
      else status = events[0].event || "Unknown";
    }

    // MAJ état local
    setEmailStatuses((prevStatuses) => ({
      ...prevStatuses,
      [messageId]: status,
    }));

    // MAJ base
    await Axios.post("/updateReminderEmailStatusByMessageId", {
      messageId,
      updates: { status },
    });

  } catch (error) {
    console.error(`❌ Erreur pour le message ID ${messageId} :`, error.message);

    const errorStatus = "Error";
    setEmailStatuses((prevStatuses) => ({
      ...prevStatuses,
      [messageId]: errorStatus,
    }));

    await Axios.post("/updateReminderEmailStatusByMessageId", {
      messageId,
      updates: { status: errorStatus },
    });
  }
};


  useEffect(() => {
    const fetchReminders = async () => {
      try {
        const response = await Axios.get("/getAllReminders");
        const remindersData = response.data.data;

        setReminders(remindersData);
        setLoadingDataReminders(false)
        for (const reminder of remindersData) {
          try {
            if (reminder.messageId) {
              await checkEmailStatus(reminder.messageId);
              
            } else {
              setEmailStatuses((prevStatuses) => ({
                ...prevStatuses,
                [reminder.messageId || reminder.id]: "No messageId",
              }));
            }
          } catch (err) {
            console.error(
              `Erreur pour le reminder ${reminder.id}:`,
              err.message
            );
          }
        }

      } catch (error) {
        setError("Erreur lors du chargement des reminders.");
   
      }
    };

    fetchReminders();
  }, []);

  // Gestion du filtrage
  const filteredReminders = reminders
    .filter((reminder) => {
      const searchText = searchTerm.toLowerCase();
      return (
       reminder.user_email && reminder.user_email.toLowerCase().includes(searchText) ||
        reminder.owner_login && reminder.owner_login.toLowerCase().includes(searchText) ||
        reminder.cabname && reminder.cabname.toLowerCase().includes(searchText)
      );
    })
    .filter((reminder) => {
      if (filterReminderType !== "all") {
        return reminder.reminderType === filterReminderType;
      }
      return true;
    })
    .filter((reminder) => {
      if (filterStatus !== "all") {
        return emailStatuses[reminder.messageId] === filterStatus;
      }
      return true;
    });

  // Gestion du tri
  const sortedReminders = [...filteredReminders].sort((a, b) => {
    if (!sortField) return 0;
    const valueA = a[sortField];
    const valueB = b[sortField];

    if (sortOrder === "asc") {
      return valueA > valueB ? 1 : -1;
    } else {
      return valueA < valueB ? 1 : -1;
    }
  });

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // Gestion de la modale
  const showModal = async (action, reminder) => {
    setModalAction(action);
    setSelectedReminder(reminder);
console.log("reminder", reminder);

    if (action === "resend") {
      try {
        const response = await Axios.get(`
          /getOwnerProfile/${reminder.user_id}`
        );
        setUserProfile(response.data.data);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération du profil utilisateur :",
          error.message
        );
        setUserProfile(null);
      }
    }

    setIsModalVisible(true);
  };

  const hideModal = () => {
    setIsModalVisible(false);
    setSelectedReminder(null);
    setModalAction(null);
  };

  const handleDelete = async () => {
    if (selectedReminder) {
      const { cabid, user_id, Eoutpout } = selectedReminder;
      try {
        const response = await Axios.post("/deleteReminderEmail", {
          cabid,
          userId: user_id,
          Eoutpout,
        });

        if (response.data.success) {
          setReminders((prevReminders) =>
            prevReminders.filter(
              (reminder) =>
                reminder.cabid !== cabid ||
                reminder.user_id !== user_id ||
                reminder.Eoutpout !== Eoutpout
            )
          );
        } else {
          console.error("Erreur : ", response.data.message);
        }
      } catch (error) {
        console.error("Erreur lors de la suppression :", error.message);
      } finally {
        hideModal();
      }
    }
  };

  const handleResend = async () => {
    if (selectedReminder) {
      const { messageId } = selectedReminder;
      try {
        const response = await Axios.post("/resendReminderEmail", {
          messageId,
        });

        if (response.data.success) {
          console.log("Email renvoyé avec succès :", response.data.message);
          toast.success("Email renvoyé avec succès !");
        } else {
          console.error(
            "Erreur lors du renvoi de l'email :",
            response.data.message
          );
          toast.error("Erreur lors du renvoi de l'email");
        }
      } catch (error) {
        console.error("Erreur lors du renvoi de l'email :", error.message);
      } finally {
        hideModal();
      }
    }
  };

  const confirmAction = () => {
    if (modalAction === "delete") {
      handleDelete();
    } else if (modalAction === "resend") {
      handleResend();
    }
  };

 
  if (error) {
    return <p>{error}</p>;
  }

  return (
    <>
      <CardHeaderPage text="Relance des calibrations" />
      <div className={styles.container}>
        <div className={styles.filters}>
          <InputForms
            type="text"
            placeholder="Rechercher..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
          <select
            value={filterReminderType}
            onChange={(e) => setFilterReminderType(e.target.value)}
            className={styles.selectInput}
          >
            <option value="all">Tous les types de relance</option>
            <option value="firstReminder">First Reminder</option>
            <option value="secondReminder">Second Reminder</option>
            <option value="thirdReminder">Third Reminder</option>
            <option value="overdueReminder">Overdue Reminder</option>
          </select>
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className={styles.selectInput}
          >
            <option value="all">Tous les statuts</option>
            <option value="hardBounces">Hard Bounces</option>
            <option value="softBounces">Soft Bounces</option>
            <option value="delivered">Delivered</option>
            <option value="opened">Opened</option>
            <option value="clicked">Clicked</option>
          </select>
        </div>
        <table className={styles.table}>
          <thead>
            <tr>
              <th onClick={() => handleSort("id")}>ID</th>
              <th onClick={() => handleSort("owner_login")}>Nom du centre</th>
              <th onClick={() => handleSort("cabname")}>Cabine</th>
              <th onClick={() => handleSort("user_name")}>Nom utilisateur</th>
              <th onClick={() => handleSort("user_email")}>Mail utilisateur</th>
              <th onClick={() => handleSort("Eoutpout")}>Transducteur</th>
              <th onClick={() => handleSort("reminderType")}>
                Type de relance
              </th>
              <th>Status Email</th>
              <th onClick={() => handleSort("created_at")}>Créé</th>
              <th onClick={() => handleSort("updated_at")}>Mis à jour</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sortedReminders.map((reminder) => (
              <tr key={reminder.id}>
                <td>{reminder.id}</td>
                <td>{reminder.owner_login}</td>
                <td>{reminder.cabname}</td>
                <td>{reminder.user_name}</td>
                <td>{reminder.user_email}</td>
                <td>{reminder.Eoutpout}</td>
                <td>{reminder.reminderType}</td>
                <td>{emailStatuses[reminder.messageId] || "En attente..."}</td>
                <td>{new Date(reminder.created_at).toLocaleString()}</td>
                <td>{new Date(reminder.updated_at).toLocaleString()}</td>
                <td>
                  <div className={styles.actions}>
                    {/* <button
                      onClick={() => showModal("delete", reminder)}
                      className={styles.deleteButton}
                    >
                      Supprimer
                    </button> */}
                    <PermissionGate actionKey={"ManageCertificat.remindCalibrationEmail"}>
                    <button
                      onClick={() => showModal("resend", reminder)}
                      className={styles.resendButton}
                    >
                      Renvoyer
                    </button>
                    </PermissionGate>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modale */}
      <Modal isShowing={isModalVisible} hide={hideModal}>
        <div className={styles.containerModal}>
          {selectedReminder && (
            <div>
              <p>
                <strong>Nom de la cabine:</strong> {selectedReminder.cabname}
              </p>
              <p>
                <strong>Nom utilisateur:</strong> {selectedReminder.user_name}
              </p>
              <p>
                <strong>Email de l'envoi précédent:</strong>{" "}
                {selectedReminder.user_email}
              </p>
              <p>
                <strong>Email actuel:</strong>{" "}
                {userProfile ? userProfile.user_email : "Chargement..."}
              </p>
              <p>
                <strong>Transducteur:</strong> {selectedReminder.Eoutpout}
              </p>
              <p>
                Êtes-vous sûr de vouloir{" "}
                {modalAction === "delete" ? "supprimer" : "renvoyer"} cet
                élément ?
              </p>
            </div>
          )}
          <div className={styles.modalActions}>
            <button
              type="button"
              onClick={hideModal}
              className={styles.deleteButton}
            >
              Annuler
            </button>
            <button
              type="button"
              onClick={confirmAction}
              className={styles.resendButton}
            >
              Confirmer
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ReminderLateCalibration;